<template>
  <page-header-wrapper>
    <div class="erp-list-page baidao-list-page">
      <div class="erp-search-card">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="5" :sm="24"><a-form-item label="盘点单号"><a-input v-model.trim="query.stocktakeNo" allow-clear placeholder="请输入盘点单号" @pressEnter="load(true)" /></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item label="盘点日期"><a-range-picker v-model="dateRange" style="width:100%" /></a-form-item></a-col>
            <a-col :md="5" :sm="24"><a-form-item label="仓库"><a-select v-model="query.warehouseId" allow-clear placeholder="全部仓库"><a-select-option v-for="wh in warehouses" :key="wh.id" :value="wh.id">{{ wh.warehouseCode }} · {{ wh.warehouseName }}</a-select-option></a-select></a-form-item></a-col>
            <a-col :md="4" :sm="24"><a-form-item label="状态"><a-select v-model="query.auditStatus" allow-clear placeholder="全部"><a-select-option value="unaudited">未审核</a-select-option><a-select-option value="audited">已审核</a-select-option><a-select-option value="reverse_audited">已反审核</a-select-option></a-select></a-form-item></a-col>
            <a-col :md="4" :sm="24" class="erp-search-actions"><a-button type="primary" icon="search" @click="load(true)">查询</a-button><a-button icon="redo" @click="resetQuery">重置</a-button></a-col>
          </a-row>
        </a-form>
      </div>
      <section class="erp-table-card">
        <div class="erp-table-toolbar">
          <div><h3>库存盘点</h3><p>按仓库和 SKU 录入实盘。审核后按当前账面生成盘盈、盘亏并记账，盘点期间不锁库存。</p></div>
          <a-button type="primary" icon="plus" @click="openCreate">新建盘点单</a-button>
        </div>
        <a-table :columns="columns" :data-source="rows" :loading="loading" row-key="id" bordered size="middle" :pagination="pagination" @change="tableChanged">
          <template slot="status" slot-scope="value"><a-tag :color="statusMeta(value).color">{{ statusMeta(value).text }}</a-tag></template>
          <template slot="actions" slot-scope="value, record">
            <a @click="openDetail(record, true)">查看</a>
            <template v-if="record.auditStatus !== 'audited'">
              <a-divider type="vertical" /><a @click="openDetail(record, false)">编辑</a>
              <a-divider type="vertical" /><a @click="confirmAudit(record)">审核</a>
              <a-divider type="vertical" /><a class="danger" @click="confirmDelete(record)">删除</a>
            </template>
            <template v-else>
              <a-divider type="vertical" /><a @click="confirmReverse(record)">反审核</a>
            </template>
          </template>
        </a-table>
      </section>
    </div>

    <a-drawer :visible="visible" :width="1080" :closable="false" :body-style="{ padding: 0 }" @close="close">
      <div class="erp-drawer-shell">
        <header class="erp-drawer-header">
          <div><button class="erp-back-button" type="button" @click="close"><a-icon type="arrow-left" /></button><span class="erp-drawer-kicker">{{ readOnly ? '查看盘点' : (form.id ? '编辑盘点' : '新建盘点') }}</span><h3>{{ form.stocktakeNo || '新建盘点单' }}</h3></div>
          <div><a-button @click="close">取消</a-button><a-button v-if="!readOnly" type="primary" :loading="saving" @click="save">保存</a-button></div>
        </header>
        <div class="erp-drawer-content">
          <section class="erp-form-card">
            <div class="erp-base-grid">
              <label><span>盘点单号</span><a-input :value="form.stocktakeNo || '保存后自动生成'" disabled /></label>
              <label><span><b>*</b> 盘点日期</span><a-date-picker v-model="form.dateValue" :disabled="readOnly" style="width:100%" /></label>
              <label><span><b>*</b> 仓库</span>
                <a-select v-model="form.warehouseId" :disabled="readOnly || !!form.id" placeholder="请选择仓库" @change="warehouseChanged">
                  <a-select-option v-for="wh in warehouses" :key="wh.id" :value="wh.id">{{ wh.warehouseCode }} · {{ wh.warehouseName }}</a-select-option>
                </a-select>
              </label>
              <label><span>盘盈原因</span><a-select v-model="form.profitReasonCode" :disabled="readOnly"><a-select-option v-for="item in profitReasons" :key="item.dictValue" :value="item.dictValue">{{ item.dictLabel }}</a-select-option></a-select></label>
              <label><span>盘亏原因</span><a-select v-model="form.lossReasonCode" :disabled="readOnly"><a-select-option v-for="item in lossReasons" :key="item.dictValue" :value="item.dictValue">{{ item.dictLabel }}</a-select-option></a-select></label>
              <label class="wide"><span>备注</span><a-input v-model="form.remark" :disabled="readOnly" :max-length="500" /></label>
            </div>
          </section>
          <section class="erp-form-card">
            <div class="erp-section-heading-row">
              <div><h4>实盘明细</h4><p>选择仓库后请按需「重新带出账面」或「追加商品」录入实盘。没有账面的商品可追加后登记盘盈。数量按基本单位。</p></div>
              <div>
                <a-button v-if="!readOnly" :disabled="!form.warehouseId" :loading="snapshotLoading" @click="loadSnapshot">重新带出账面</a-button>
                <a-button v-if="!readOnly" type="primary" ghost icon="plus" :disabled="!form.warehouseId" @click="openSkuPicker">追加商品</a-button>
              </div>
            </div>
            <a-table :columns="lineColumns" :data-source="form.items" :pagination="false" row-key="rowKey" size="small" :scroll="{ x: 980 }">
              <template slot="snapshot" slot-scope="value">{{ qtyText(value) }}</template>
              <template slot="actual" slot-scope="value, record">
                <span v-if="readOnly">{{ qtyText(record.qtyActual) }}</span>
                <a-input-number v-else v-model="record.qtyActual" :min="0" :precision="3" :step="0.001" style="width:120px" />
              </template>
              <template slot="cost" slot-scope="value, record"><a-input-number v-model="record.costPrice" :disabled="readOnly" :min="0" :precision="6" style="width:120px" /></template>
              <template slot="diff" slot-scope="value, record"><span :class="diffClass(record)">{{ diffText(record) }}</span></template>
              <template slot="lineAction" slot-scope="value, record, index"><a v-if="!readOnly" @click="form.items.splice(index, 1)">移除</a></template>
            </a-table>
          </section>
        </div>
      </div>
    </a-drawer>

    <a-modal
      title="选择商品"
      :visible="skuPicker.visible"
      width="1120px"
      class="erp-picker-modal product-picker-modal"
      :body-style="{ padding: '18px 20px 12px' }"
      :confirm-loading="skuPicker.loading"
      ok-text="添加到明细"
      cancel-text="取消"
      @ok="confirmSkuPicker"
      @cancel="closeSkuPicker"
    >
      <div class="product-picker-panel">
        <div class="product-picker-search">
          <label class="product-picker-field">
            <span>商品关键字</span>
            <a-input
              v-model="skuPicker.keyword"
              allow-clear
              placeholder="商品名称、商品编码、SKU编码、规格"
              @pressEnter="searchSku"
            />
          </label>
          <div class="product-picker-actions">
            <a-button type="primary" @click="searchSku"><a-icon type="search" />查询</a-button>
            <a-button @click="resetSkuPicker"><a-icon type="redo" />重置</a-button>
          </div>
        </div>
        <div class="product-picker-tip">
          <span><a-icon type="info-circle" /> 当前盘点仓：{{ selectedStocktakeWarehouseText }}；从商品档案选择启用 SKU，不输入关键字显示前 100 条（含账面为 0 可盘盈）</span>
          <span class="selected-product-count"><a-icon type="check-circle" /> 已选 {{ skuPicker.selectedRowKeys.length }} 个 SKU</span>
        </div>
      </div>
      <a-table
        row-key="skuId"
        size="small"
        bordered
        :columns="skuPickerColumns"
        :data-source="skuPicker.list"
        :loading="skuPicker.loading"
        :pagination="false"
        :row-selection="skuPickerRowSelection"
        :scroll="{ x: 1100, y: 400 }"
        :row-class-name="skuPickerRowClassName"
        :locale="{ emptyText: '暂无匹配商品，请换关键词或在商品档案中维护启用 SKU' }"
      >
        <template slot="spu" slot-scope="text, record">
          <div class="picker-product-main">
            <strong>{{ record.spuName || record.skuName || '未命名商品' }}</strong>
            <span>{{ record.spuCode || '无商品编码' }}</span>
          </div>
        </template>
        <template slot="sku" slot-scope="text, record">
          <div class="picker-product-main">
            <strong>{{ record.skuName || '未命名 SKU' }}</strong>
            <span>{{ record.skuCode || '无 SKU 编码' }}</span>
          </div>
        </template>
        <template slot="spec" slot-scope="text, record">
          {{ record.specName || '—' }}
        </template>
        <template slot="baseUnitName" slot-scope="text, record">
          {{ record.unitName || text || '—' }}
        </template>
        <template slot="categoryName" slot-scope="text">
          {{ text || '未分类' }}
        </template>
        <template slot="brandName" slot-scope="text">
          {{ text || '—' }}
        </template>
        <template slot="ledgerQty" slot-scope="text, record">
          {{ qtyText(record.qtyBalance) }}
        </template>
      </a-table>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import moment from 'moment'
import { listWarehouse } from '@/api/erp/warehouse'
import { getDicts } from '@/api/system/dict/data'
import { listStocktake, getStocktake, stocktakeSnapshot, stocktakeSkuOptions, stocktakeResolveItems, saveStocktake, auditStocktake, reverseAuditStocktake, deleteStocktake } from '@/api/erp/stock'

export default {
  name: 'ErpStocktake',
  data () {
    return {
      query: {},
      dateRange: [],
      warehouses: [],
      profitReasons: [],
      lossReasons: [],
      rows: [],
      loading: false,
      pagination: { current: 1, pageSize: 20, total: 0 },
      columns: [
        { title: '盘点单号', dataIndex: 'stocktakeNo' },
        { title: '盘点日期', dataIndex: 'stocktakeDate' },
        { title: '仓库', dataIndex: 'warehouseName' },
        { title: '状态', dataIndex: 'auditStatus', scopedSlots: { customRender: 'status' } },
        { title: '差异', dataIndex: 'differenceStatus', customRender: value => value === 'generated' ? '已生成盈亏' : '无差异或未处理' },
        { title: '操作', scopedSlots: { customRender: 'actions' }, width: 220 }
      ],
      visible: false,
      readOnly: false,
      saving: false,
      snapshotLoading: false,
      form: { items: [], profitReasonCode: 'stocktake_diff', lossReasonCode: 'stocktake_diff' },
      lineColumns: [
        { title: 'SKU', dataIndex: 'skuCode', width: 140 },
        { title: '商品', dataIndex: 'skuName' },
        { title: '单位', dataIndex: 'unitName', width: 80 },
        { title: '账面快照', dataIndex: 'qtySnapshot', scopedSlots: { customRender: 'snapshot' }, width: 110 },
        { title: '实盘数量', scopedSlots: { customRender: 'actual' }, width: 140 },
        { title: '盘盈成本', scopedSlots: { customRender: 'cost' }, width: 140 },
        { title: '相对快照差异', scopedSlots: { customRender: 'diff' }, width: 120 },
        { title: '', scopedSlots: { customRender: 'lineAction' }, width: 70 }
      ],
      skuPicker: {
        visible: false,
        loading: false,
        keyword: '',
        list: [],
        selectedRowKeys: [],
        selectedProducts: []
      },
      skuPickerColumns: [
        { title: '商品', dataIndex: 'spuName', width: 220, scopedSlots: { customRender: 'spu' } },
        { title: 'SKU', dataIndex: 'skuName', width: 230, scopedSlots: { customRender: 'sku' } },
        { title: '规格', dataIndex: 'specName', width: 150, scopedSlots: { customRender: 'spec' } },
        { title: '基本单位', dataIndex: 'unitName', width: 90, scopedSlots: { customRender: 'baseUnitName' } },
        { title: '台账库存', dataIndex: 'qtyBalance', width: 100, align: 'right', scopedSlots: { customRender: 'ledgerQty' } },
        { title: '商品分类', dataIndex: 'categoryName', width: 140, scopedSlots: { customRender: 'categoryName' } },
        { title: '品牌', dataIndex: 'brandName', width: 120, scopedSlots: { customRender: 'brandName' } }
      ]
    }
  },
  computed: {
    selectedStocktakeWarehouseText () {
      const wh = this.warehouses.find(row => String(row.id) === String(this.form.warehouseId))
      return wh ? `${wh.warehouseCode} · ${wh.warehouseName}` : '未选择'
    },
    skuPickerRowSelection () {
      return {
        selectedRowKeys: this.skuPicker.selectedRowKeys,
        onChange: this.handleSkuPickerSelectionChange
      }
    }
  },
  created () {
    listWarehouse(true).then(res => { this.warehouses = (res.data || []).filter(row => row.status === 'enabled') }).catch(() => {})
    getDicts('warehouse_profit_reason').then(res => { this.profitReasons = res.data || [] }).catch(() => {})
    getDicts('warehouse_loss_reason').then(res => { this.lossReasons = res.data || [] }).catch(() => {})
    this.load(true)
  },
  methods: {
    statusMeta (value) {
      if (value === 'audited') return { text: '已审核', color: 'green' }
      if (value === 'reverse_audited') return { text: '已反审核', color: 'orange' }
      return { text: '未审核', color: 'blue' }
    },
    load (reset) {
      if (reset) this.pagination.current = 1
      const params = { ...this.query, pageNum: this.pagination.current, pageSize: this.pagination.pageSize }
      if (this.dateRange && this.dateRange.length === 2) {
        params.dateStart = this.dateRange[0].format('YYYY-MM-DD')
        params.dateEnd = this.dateRange[1].format('YYYY-MM-DD')
      }
      this.loading = true
      listStocktake(params).then(res => {
        const page = res.data || {}
        this.rows = page.records || []
        this.pagination.total = page.total || 0
      }).catch(e => this.$message.error((e && e.message) || '加载失败')).finally(() => { this.loading = false })
    },
    tableChanged (pager) { this.pagination.current = pager.current; this.load(false) },
    resetQuery () { this.query = {}; this.dateRange = []; this.load(true) },
    openCreate () {
      this.readOnly = false
      this.form = { items: [], profitReasonCode: 'stocktake_diff', lossReasonCode: 'stocktake_diff', dateValue: moment() }
      this.visible = true
    },
    openDetail (record, readOnly) {
      getStocktake(record.id).then(res => {
        const data = res.data || {}
        data.dateValue = data.stocktakeDate ? moment(data.stocktakeDate) : moment()
        data.items = (data.items || []).map((item, index) => this.normalizeLine(item, item.id || index))
        this.form = data
        this.readOnly = readOnly
        this.visible = true
      }).catch(e => this.$message.error((e && e.message) || '加载失败'))
    },
    close () { this.visible = false },
    warehouseChanged () {
      if (this.readOnly || this.form.id) return
      this.form.items = []
    },
    loadSnapshot () {
      if (!this.form.warehouseId) return
      this.snapshotLoading = true
      stocktakeSnapshot(this.form.warehouseId).then(res => {
        this.form.items = (res.data || []).map((item, index) => this.normalizeLine({
          ...item,
          costPrice: item.costPrice || 0
        }, 's' + item.skuId + index))
        if (!this.form.items.length) this.$message.info('该仓库当前没有账面大于 0 的商品，可追加商品做盘盈')
      }).catch(e => this.$message.error((e && e.message) || '带出账面失败')).finally(() => { this.snapshotLoading = false })
    },
    openSkuPicker () {
      this.skuPicker.keyword = ''
      this.skuPicker.selectedRowKeys = []
      this.skuPicker.selectedProducts = []
      this.skuPicker.visible = true
      this.searchSku('')
    },
    closeSkuPicker () {
      this.skuPicker.visible = false
      this.skuPicker.list = []
      this.skuPicker.selectedRowKeys = []
      this.skuPicker.selectedProducts = []
    },
    resetSkuPicker () {
      this.skuPicker.keyword = ''
      this.searchSku('')
    },
    searchSku () {
      if (!this.form.warehouseId) {
        this.$message.warning('请先选择盘点仓库')
        return
      }
      const kw = (this.skuPicker.keyword || '').trim()
      this.skuPicker.loading = true
      stocktakeSkuOptions(this.form.warehouseId, kw).then(res => {
        const existing = new Set(this.form.items.map(item => String(item.skuId)))
        this.skuPicker.list = (res.data || []).filter(row => !existing.has(String(row.skuId)))
      }).catch(e => {
        this.skuPicker.list = []
        this.$message.error((e && e.message) || '查询失败')
      }).finally(() => { this.skuPicker.loading = false })
    },
    handleSkuPickerSelectionChange (selectedRowKeys, selectedRows) {
      const productMap = {}
      this.skuPicker.selectedProducts.forEach(row => { productMap[String(row.skuId)] = row })
      selectedRows.forEach(row => { productMap[String(row.skuId)] = row })
      this.skuPicker.selectedRowKeys = selectedRowKeys
      this.skuPicker.selectedProducts = selectedRowKeys
        .map(key => productMap[String(key)])
        .filter(Boolean)
    },
    skuPickerRowClassName (record) {
      return this.skuPicker.selectedRowKeys.some(key => String(key) === String(record.skuId)) ? 'product-row-selected' : ''
    },
    appendResolvedSkuLines (lines) {
      let added = 0
      ;(lines || []).forEach((item, index) => {
        if (this.form.items.some(line => String(line.skuId) === String(item.skuId))) return
        this.form.items.push(this.normalizeLine({
          skuId: item.skuId,
          skuCode: item.skuCode,
          skuName: item.skuName,
          unitName: item.unitName,
          qtySnapshot: item.qtySnapshot,
          qtyActual: item.qtyActual,
          qtyCurrent: item.qtyCurrent,
          costPrice: item.costPrice || 0
        }, 'n' + item.skuId + '-' + index + '-' + Date.now()))
        added += 1
      })
      if (added) this.$message.success(`已添加 ${added} 个 SKU，账面数量已从台账带出`)
      this.closeSkuPicker()
      return added
    },
    resolveSkuLinesFallback (selectedProducts) {
      return Promise.resolve(selectedProducts.map(sku => {
        const qty = sku.qtyBalance != null ? sku.qtyBalance : 0
        return {
          skuId: sku.skuId,
          skuCode: sku.skuCode,
          skuName: sku.skuName,
          unitName: sku.unitName,
          qtySnapshot: qty,
          qtyActual: qty,
          qtyCurrent: qty,
          costPrice: 0
        }
      }))
    },
    confirmSkuPicker () {
      if (!this.skuPicker.selectedProducts.length) {
        this.$message.warning('请至少选择一个商品 SKU')
        return
      }
      const selectedProducts = this.skuPicker.selectedProducts.slice()
      const skuIds = selectedProducts.map(row => row.skuId).filter(Boolean)
      this.skuPicker.loading = true
      const loadLines = () => stocktakeResolveItems(this.form.warehouseId, skuIds).then(res => res.data || [])
        .catch(err => {
          const status = err && err.response && err.response.status
          const msg = (err && err.message) || ''
          if (status === 404 || (msg && msg.indexOf('Not Found') >= 0)) {
            return this.resolveSkuLinesFallback(selectedProducts)
          }
          return Promise.reject(err)
        })
      return loadLines().then(lines => {
        this.appendResolvedSkuLines(lines)
      }).catch(e => {
        this.$message.error((e && e.message) || '带出台账库存失败')
        return Promise.reject(e)
      }).finally(() => { this.skuPicker.loading = false })
    },
    qtyRound (value) {
      return Math.round(Number(value || 0) * 1000) / 1000
    },
    normalizeLine (item, rowKey) {
      return {
        ...item,
        rowKey,
        qtySnapshot: this.qtyRound(item.qtySnapshot),
        qtyActual: this.qtyRound(item.qtyActual),
        qtyCurrent: item.qtyCurrent == null ? item.qtyCurrent : this.qtyRound(item.qtyCurrent),
        qtyDifference: item.qtyDifference == null ? item.qtyDifference : this.qtyRound(item.qtyDifference)
      }
    },
    qtyText (value) {
      return this.qtyRound(value).toFixed(3)
    },
    diffText (record) {
      const diff = Number(record.qtyActual || 0) - Number(record.qtySnapshot || 0)
      const text = this.qtyText(diff)
      return diff > 0 ? '+' + text : text
    },
    diffClass (record) {
      const diff = Number(record.qtyActual || 0) - Number(record.qtySnapshot || 0)
      return diff > 0 ? 'profit' : (diff < 0 ? 'loss' : '')
    },
    save () {
      if (!this.form.warehouseId || !this.form.dateValue) {
        this.$message.warning('请选择仓库和盘点日期')
        return
      }
      if (!this.form.items.length) {
        this.$message.warning('请先带出账面或追加商品')
        return
      }
      const payload = {
        id: this.form.id,
        stocktakeDate: this.form.dateValue.format('YYYY-MM-DD'),
        warehouseId: this.form.warehouseId,
        profitReasonCode: this.form.profitReasonCode || 'stocktake_diff',
        lossReasonCode: this.form.lossReasonCode || 'stocktake_diff',
        remark: this.form.remark,
        items: this.form.items.map(item => ({
          skuId: item.skuId,
          qtySnapshot: item.qtySnapshot || 0,
          qtyActual: item.qtyActual || 0,
          costPrice: item.costPrice || 0,
          remark: item.remark
        }))
      }
      this.saving = true
      saveStocktake(payload).then(() => {
        this.$message.success('已保存')
        this.visible = false
        this.load(false)
      }).catch(e => this.$message.error((e && e.message) || '保存失败')).finally(() => { this.saving = false })
    },
    confirmAudit (record) {
      this.$confirm({
        title: '审核盘点单',
        content: '审核后按当前账面与实盘的差额记账。账面相对快照有变化时会再确认一次。',
        onOk: () => this.doAudit(record.id, false)
      })
    },
    doAudit (id, confirmed) {
      return auditStocktake(id, confirmed).then(() => {
        this.$message.success('审核完成，库存已按差异调整')
        this.load(false)
      }).catch(e => {
        const message = (e && e.message) || '审核失败'
        if (!confirmed && message.indexOf('账面相对快照已变化') >= 0) {
          this.$confirm({ title: '账面已变化', content: message, onOk: () => this.doAudit(id, true) })
          return
        }
        this.$message.error(message)
      })
    },
    confirmReverse (record) {
      this.$confirm({
        title: '反审核盘点单',
        content: '将反冲本次盘盈、盘亏。盘盈库存若已被占用或后续使用，会拒绝反审核。',
        onOk: () => reverseAuditStocktake(record.id).then(() => { this.$message.success('已反审核'); this.load(false) }).catch(e => this.$message.error((e && e.message) || '反审核失败'))
      })
    },
    confirmDelete (record) {
      this.$confirm({
        title: '删除盘点单',
        content: '未审核的盘点单删除后不再出现在列表。',
        onOk: () => deleteStocktake(record.id).then(() => { this.$message.success('已删除'); this.load(false) }).catch(e => this.$message.error((e && e.message) || '删除失败'))
      })
    }
  }
}
</script>

<style scoped>
.danger { color: #cf1322; }
.profit { color: #389e0d; }
.loss { color: #cf1322; }
.erp-section-heading-row { display: flex; justify-content: space-between; align-items: flex-start; gap: 12px; margin-bottom: 12px; }
.erp-base-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.erp-base-grid .wide { grid-column: 1 / -1; }
.erp-base-grid label { display: flex; flex-direction: column; gap: 6px; }
.product-picker-panel{border:1px solid #e8edf5;border-radius:8px;background:#f8fbff;padding:12px 14px;margin-bottom:12px}
.product-picker-search{display:grid;grid-template-columns:minmax(360px,1fr) auto;gap:14px;align-items:end}
.product-picker-field{display:grid;gap:6px;margin:0;color:#526071;font-size:12px;font-weight:600}
.product-picker-field /deep/ .ant-input{height:32px;font-weight:400}
.product-picker-actions{display:flex;gap:8px}
.product-picker-actions /deep/ .ant-btn{height:32px}
.product-picker-tip{display:flex;justify-content:space-between;align-items:center;gap:12px;margin-top:11px;color:#8b96a8;font-size:12px;line-height:20px}
.selected-product-count{display:inline-flex;align-items:center;gap:5px;color:#1677ff;background:#edf6ff;border:1px solid #cfe8ff;border-radius:12px;padding:1px 10px;white-space:nowrap}
.product-picker-modal{max-width:calc(100vw - 32px)}
.product-picker-modal /deep/ .ant-modal-header{border-bottom:1px solid #edf1f6;padding:16px 20px}
.product-picker-modal /deep/ .ant-modal-title{font-weight:700;color:#253142}
.product-picker-modal /deep/ .ant-modal-footer{border-top:1px solid #edf1f6;padding:12px 20px}
.product-picker-modal /deep/ .ant-table-wrapper{border-radius:8px;overflow:hidden}
.product-picker-modal /deep/ .ant-table-thead > tr > th{background:#f5f7fb;color:#526071;font-weight:600}
.product-picker-modal /deep/ .ant-table-tbody > tr.product-row-selected > td{background:#eaf4ff}
.product-picker-modal /deep/ .ant-table-scroll .ant-table-body{overflow-x:auto!important}
.picker-product-main strong,.picker-product-main span{display:block}
.picker-product-main strong{color:#253142;font-weight:600}
.picker-product-main span{margin-top:2px;color:#8b96a8;font-family:Menlo,Consolas,monospace;font-size:12px}
@media (max-width: 760px){
  .product-picker-search{grid-template-columns:1fr}
  .product-picker-actions{justify-content:flex-end}
  .product-picker-tip{align-items:flex-start;flex-direction:column}
}
</style>
